export default __webpack_public_path__ + "5516daeb9c5cf55021d96973c592ec8c.jpg";